// Created by carsonaberle at 5/14/22
import styled from 'styled-components';

export const div_ListingContentContainer = styled.div``;

export const div_ListingContentTabBar = styled.div`
	padding: 12px;
`;

export const div_ListingContentPage = styled.div``;
